import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { AsyncCallArgs, CardSpg, CircularLoader, useAsyncCall, ViewSection } from "@duosoftbg/nacid-components";
import React, { useEffect, useState } from "react";
import { getFullUserDetails } from "../../../../../axios/api/services";
import { useSearchParams } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import UserMainDetailsDisplay from "../dialog/parts/UserMainDetailsDisplay";
import ScrollableGridContainer from "../../../common/grid/ScrollableGridContainer";
import RolesDialogList from "../../groupsAndRoles/dialog/parts/RolesDialogList";
import GroupsDialogList from "../../groupsAndRoles/dialog/parts/GroupsDialogList";

const UserView = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (id) {
      const getUserCallArgs: AsyncCallArgs = {
        promise: getFullUserDetails(id),
        onSuccess: (response) => {
          setUser(response);
        },
        onError: () => {
          setUser(null);
        },
      };
      asyncCall(getUserCallArgs);
    }
  }, [id, asyncCall, dispatch, t]);

  return (
    <CardSpg my={4} style={{ overflow: "visible" }}>
      <CardContent style={{ padding: 24, position: "relative" }}>
        {!user && <CircularLoader />}
        {user && (
          <>
            <UserMainDetailsDisplay record={user.user} />
            <ViewSection label={"t.user.roles"}>
              <ScrollableGridContainer>
                <RolesDialogList roles={user.roles} isEdit={false} />
              </ScrollableGridContainer>
            </ViewSection>
            <ViewSection label={"t.user.groups"}>
              <ScrollableGridContainer>
                <GroupsDialogList groups={user.groups} isEdit={false} />
              </ScrollableGridContainer>
            </ViewSection>
          </>
        )}
      </CardContent>
    </CardSpg>
  );
};
export default UserView;
